/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useCallback, useMemo } from 'react';

import classnames from 'classnames';

import LinkButton from 'components/uiLibrary/LinkButton';
import SpriteIcon from 'components/uiLibrary/SpriteIcon';
import Typography from 'components/uiLibrary/Typography';

import EntityName from 'components/Globals/EntityName';

import { TP, CASTING_TOOL_SLUGS } from 'constants/index';

import { getWorkRoleProfessions } from 'utils/common';
import { useDialogs } from 'utils/hooks/useDialogs';
import useNavigate from 'utils/hooks/useNavigate';

import { useTranslation } from 'src/i18n';

import classes from './RoleEntityBlock.module.scss';

const getTrackingDataForClick = (trackingData, item) => ({
  ...trackingData,
  entityType: item?.entityType,
  entityId: item?.entity?.id,
  entityName: item?.entity?.name,
});

const RoleEntityBlock = ({
  item,
  trackingData = {},
  handleOnClick,
  styles = { roleEntityDetails: '' },
  handleRoleSelect,
}) => {
  const { t } = useTranslation('NS_APP_GLOBALS');
  const navigate = useNavigate();
  const { isJumpInSelectProductionsModalOpen } = useDialogs();
  const { title, data, professionId, workRoleId, allProgram } = item || {};
  const works = useMemo(
    () =>
      item?.works
        ? [...new Set(item.works.map(work => work?.id))].map(workId => item.works.find(work => work?.id === workId))
        : [],
    [item?.works],
  );

  const id = professionId || workRoleId;
  const type = professionId ? CASTING_TOOL_SLUGS.PROFESSION : CASTING_TOOL_SLUGS.WORK_ROLE;

  const getLinkProps = useCallback((entity, entityType) => navigate?.getLinkProps({ entity, entityType }), [navigate]);

  return (
    <div
      className={classnames(classes.roleEntityDetails, { [styles.roleEntityDetails]: !!styles.roleEntityDetails })}
      key={title}
    >
      <span
        className={classes.roleEntityDetails__header}
        onClick={() => {
          if (id && isJumpInSelectProductionsModalOpen) {
            handleRoleSelect({ id, type, works });
          }
        }}
      >
        <Typography
          size="12"
          italic
          className={classnames(classes.roleEntityDetails__header_role, {
            [classes.roleJumpInRole]: isJumpInSelectProductionsModalOpen,
          })}
        >
          {t(title)}
          {isJumpInSelectProductionsModalOpen && title && <SpriteIcon icon="chevron_right" size={14} />}
        </Typography>
        {isJumpInSelectProductionsModalOpen && (
          <>
            {item?.workRoleProfessions?.length ? (
              <Typography color="secondary" size={10} className={classes.workRoleProfession}>
                {getWorkRoleProfessions(item?.workRoleProfessions)}
              </Typography>
            ) : null}
            {allProgram && (
              <Typography size={10} italic>
                {t(`${TP}.ALL_PROGRAM`)}
              </Typography>
            )}
            {!allProgram &&
              works?.map(work => (
                <Typography key={work?.id} size={10} italic>
                  {work?.name}
                </Typography>
              ))}
          </>
        )}
      </span>
      <div className={classes.list}>
        {data?.map(({ entity, entityType, id: uniqueKey, isCurrentEntity }) => (
          <span className={classnames(classes.item, { [classes.itemDot]: data?.length > 1 })} key={entity?.id}>
            <LinkButton
              target="_blank"
              variant="text"
              isLink
              {...getLinkProps(entity, entityType)}
              styles={{
                root: classnames(classes.name, {
                  [classes.name__redMask]: isCurrentEntity,
                  [classes.name__bold]: isCurrentEntity,
                  [classes.name__jumpIn]: isJumpInSelectProductionsModalOpen,
                }),
              }}
              key={uniqueKey}
              onClick={handleOnClick}
              trackingData={getTrackingDataForClick(trackingData, item)}
            >
              {isCurrentEntity && <SpriteIcon icon="red_mask" size={12} className={classes.redmask} />}
              <EntityName
                entityType={entityType}
                entity={{ id: entity?.id, name: entity?.name }}
                trackingData={trackingData}
                isRaw
              />
              {item?.isCover && <span className={classes.coverRole}>({t(`${TP}.FN_COVER`)})</span>}
            </LinkButton>
          </span>
        ))}
      </div>
    </div>
  );
};

export default RoleEntityBlock;
